import Contract from "slotworks/utils/contract";
abstract class AbstractMediator {

    public start(): Contract<any> {
        return new Contract<any>((resolve) => {
            resolve(null);
        });
    }

    public end() {
        // Cancel
    }

}

export default AbstractMediator;



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/mediators/abstract-mediator.ts